import { render, staticRenderFns } from "./PayrollSidelist.vue?vue&type=template&id=4fc43eb5"
import script from "./PayrollSidelist.vue?vue&type=script&lang=js"
export * from "./PayrollSidelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports